/**
 * Locale bundles of the LinkedIn Network & Insights screens (FLAT `linkedinNetwork.*` keys plus the marketing
 * hub page title). Explicit requires (Metro cannot resolve dynamic paths); merged into the single `translation`
 * namespace through locales/adminModules/index.js -> i18n.js.
 */
const BUNDLES = {
    hu: () => require('./hu.json'),
    en: () => require('./en.json'),
    de: () => require('./de.json'),
    ro: () => require('./ro.json'),
    cn: () => require('./cn.json'),
    svn: () => require('./svn.json'),
};

/**
 * @param {string} lng Language code (hu|en|de|ro|cn|svn).
 * @returns {object} Keys for the language ({} when unknown).
 */
export const getLinkedinNetworkLocale = (lng) => (BUNDLES[lng] ? BUNDLES[lng]() : {});

export default getLinkedinNetworkLocale;
